export const userReducer = (previousState = {}) => {
    return previousState
}
